
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class InvoiceService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.inv_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_INVOICE_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getInvoicePageList(input, responseCallBack, errorCallBack) {
    this.method("getInvoicePageList", input, responseCallBack, errorCallBack);
  }
  static initInvoiceModule(input, responseCallBack, errorCallBack) {
    this.method("initInvoiceModule", input, responseCallBack, errorCallBack);
  }
  static readInvoice(input, responseCallBack, errorCallBack) {
    this.method("readInvoice", input, responseCallBack, errorCallBack);
  }
  static createInvoice(input, responseCallBack, errorCallBack) {
    this.method("createInvoice", input, responseCallBack, errorCallBack);
  }
  static updateAndApproveInvoice(input, responseCallBack, errorCallBack) {
    this.method(
      "updateAndApproveInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateInvoice(input, responseCallBack, errorCallBack) {
    this.method("updateInvoice", input, responseCallBack, errorCallBack);
  }
  static cancelInvoice(input, responseCallBack, errorCallBack) {
    this.method("cancelInvoice", input, responseCallBack, errorCallBack);
  }
  static unApproveInvoice(input, responseCallBack, errorCallBack) {
    this.method("unApproveInvoice", input, responseCallBack, errorCallBack);
  }
  static unLockInvoice(input, responseCallBack, errorCallBack) {
    this.method("unLockInvoice", input, responseCallBack, errorCallBack);
  }
  static updateInvoiceAfterApproval(input, responseCallBack, errorCallBack) {
    this.method(
      "updateInvoiceAfterApproval",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateSalesPersonToInvoice(input, responseCallBack, errorCallBack) {
    this.method(
      "updateSalesPersonToInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static fetchInvoiceMailCustomerDefaultInfoBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "fetchInvoiceMailCustomerDefaultInfoBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static sendSalesInvoiceCustomerMail(input, responseCallBack, errorCallBack) {
    this.method(
      "sendSalesInvoiceCustomerMail",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateInvoiceCommentsAfterApproval(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateInvoiceCommentsAfterApproval",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static updateSalesCommissionTransaction(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "updateSalesCommissionTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createSalesCommissionTransaction(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createSalesCommissionTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static paidSalesCommissionTransaction(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "paidSalesCommissionTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveSalesCommissionTransaction(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "approveSalesCommissionTransaction",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getSalesCommissionTransactionAllRecordDetails(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getSalesCommissionTransactionAllRecordDetails",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static approveInvoiceThenGenerateInvoiceReport(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "approveInvoiceThenGenerateInvoiceReport",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getnvoicesDetailsForCommercialInvoice(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getnvoicesDetailsForCommercialInvoice",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static createInvoiceForMultiplePickTicket(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "createInvoiceForMultiplePickTicket",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getMultiplePickedPickTicket(input, responseCallBack, errorCallBack) {
    this.method(
      "getMultiplePickedPickTicket",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static fetchMultiInvoicesMailDefaultInfoBean(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "fetchMultiInvoicesMailDefaultInfoBean",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static sendSalesMultiInvoiceMail(input, responseCallBack, errorCallBack) {
    this.method(
      "sendSalesMultiInvoiceMail",
      input,
      responseCallBack,
      errorCallBack
    );
  }

  static getUnApprovedInvoicesForCustomer(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getUnApprovedInvoicesForCustomer",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static getOpenInvoicesForAccountReceivable(
    input,
    responseCallBack,
    errorCallBack
  ) {
    this.method(
      "getOpenInvoicesForAccountReceivable",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static cancelInvoiceServiceLine(input, responseCallBack, errorCallBack) {
    this.method(
      "cancelInvoiceServiceLine",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static invoiceImageUpload(input, responseCallBack, errorCallBack) {
    this.method("invoiceImageUpload", input, responseCallBack, errorCallBack);
  }
  static invoiceDocUpload(input, responseCallBack, errorCallBack) {
    this.method("invoiceDocUpload", input, responseCallBack, errorCallBack);
  }

  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.inv_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
      ServiceExecutorProxy.executeService(methodName, input,this.inv_data_url,responseCallBack, errorCallBack);

    }
  }
}
